import StarredChannels from "discourse/plugins/chat/discourse/components/chat/routes/starred-channels";

export default <template><StarredChannels /></template>
